import { render, staticRenderFns } from "./section-toggle.vue?vue&type=template&id=4a46cce5&scoped=true&"
import script from "./section-toggle.vue?vue&type=script&lang=ts&"
export * from "./section-toggle.vue?vue&type=script&lang=ts&"
import style0 from "./section-toggle.vue?vue&type=style&index=0&id=4a46cce5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a46cce5",
  null
  
)

export default component.exports